<!-- 礼品管理 Gmanagement-->
<template>
  <div class="Gmanagement">
    <div class="form_header">
      <el-form ref="form" :model="Gmanform" label-width="100px">
        <div class="form_list">
          <el-form-item label="礼品名称：">
            <el-select v-model="Gmanform.cg_id" placeholder="请选择礼品名称">
              <el-option v-for="item in SpecifList" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="状态：">
            <el-select v-model="Gmanform.status" placeholder="请选择状态">
              <el-option label="未使用" value="1"></el-option>
              <el-option label="已使用" value="0"></el-option>
            </el-select>
          </el-form-item>
          <div class="btn_box">
            <el-button type="primary" @click="onSubmit">搜索</el-button>
            <el-button @click="nosubmint">取消</el-button>
          </div>
        </div>
      </el-form>
      <div class="form_ri">
        <el-button type="primary" icon="el-icon-tickets" @click="mode">下载模板</el-button>
        <el-upload class="upload-demo" action accept=".xlsx, .xls, .csv" :show-file-list="false" :http-request="handlePreview" :limit="1">
          <el-button type="primary" icon="el-icon-download">导入</el-button>
        </el-upload>
        <el-button type="primary" icon="el-icon-upload2" @click="exportto">导出</el-button>
        <el-button type="primary" icon="el-icon-plus" @click="addPoints">新增</el-button>
      </div>
    </div>
    <div class="user_list">
      <el-table :data="giftsList" style="width: 100%" @selection-change="handleSelectionChange" :header-cell-style="rowStyle" :cell-style="rowStyle">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column type="index" label="序号" width="50"></el-table-column>
        <el-table-column prop="name" label="礼品分类">
          <template slot-scope="scope">
            <span>{{scope.row.category.name}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="secret_key" label="兑换秘钥"></el-table-column>
        <el-table-column prop="integral" label="兑换所需积分">
          <template slot-scope="scope">
            <span>{{scope.row.category.integral}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="状态">
          <template slot-scope="scope">
            <span v-if="scope.row.status==0">已使用</span>
            <span v-if="scope.row.status==1">未使用</span>
          </template>
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="180">
          <template slot-scope="scope">
            <el-button @click="handleClick(scope.row)" type="text" size="small">复制</el-button>
            <el-button v-if="scope.row.status==1" type="text" size="small" @click="editbox(scope.row)">编辑</el-button>
            <el-button v-if="scope.row.status==1" type="text" size="small" @click="delbox(scope.row)">删除</el-button>
            <!-- <el-button type="text" size="small">禁用</el-button>
            <el-button type="text" size="small">启用</el-button>-->
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="fy_box">
      <el-pagination @current-change="handleCurrentChange" background prev-text="上一页" next-text="下一页" :current-page="currentindex" :page-size="pageSize" layout="total,prev, pager, next, jumper" :total="totals"></el-pagination>
    </div>
    <!-- 新增--编辑弹窗 -->
    <el-dialog :title="titleName" :visible.sync="pop_up" @close="noadd">
      <el-form :model="Edform" :rules="rules" label-width="100px">
        <el-form-item label="礼品分类">
          <el-select v-model="Edform.cg_id" placeholder="请选择礼品">
            <el-option v-for="item in SpecifList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="兑换秘钥">
          <el-input v-model="Edform.secret_key"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="noadd">取 消</el-button>
        <el-button type="primary" @click="SubmitAdd">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import { categoryGiftlists } from "../../api/system.js";
import { giftlists, giftadd, giftedit,giftDel } from "../../api/gift.js";
import { gifttemplate, excelimport, excelexport } from "../../api/comm.js";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      Gmanform: {
        cg_id: "",
        status: ""
      },
      SpecifList: [],
      Edform: {
        cg_id: "",
        secret_key: ""
      },
      giftsList: [
        {
          name: "9f30002",
          category: {
            name: ""
          },
          name1: "已发放"
        }
      ],
      currentindex: 1,
      pageSize: 10,
      totals: 100,
      titleName: "新增",
      pop_up: false,
      rules: {
        reason: [{ required: true, message: "请输入拒绝原因", trigger: "blur" }]
      },
      Checklist: []
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    rowStyle() {
      return { textAlign: "center" };
    },
    //礼品分类
    giftdata() {
      let data = {
        page: "",
        page_size: "",
        currency_id:parseInt(localStorage.getItem('countryId'))
      };
      categoryGiftlists(data).then(res => {
        // console.log(res);
        if (res.status_code == 200) {
          this.SpecifList = res.data.data;
        }
      });
    },
    //礼品列表
    giftListd() {
      let data = {
        page: this.currentindex,
        page_size: this.pageSize,
        cg_id: this.Gmanform.cg_id,
        status: this.Gmanform.status,
        currency_id:parseInt(localStorage.getItem('countryId'))
      };
      giftlists(data).then(res => {
        // console.log(res);
        if (res.status_code == 200) {
          this.giftsList = res.data.data;
          this.totals = res.data.total;
        }
      });
    },
    delbox(e){
      let data = {
        id: e.id
      };
      this.$confirm("此操作将删除该礼品, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          giftDel(data).then(res => {
            if (res.status_code == 200) {
              this.currentindex = 1;
              this.giftListd();
              this.$message({
                type: "success",
                message: "删除成功!"
              });
            }
          });
        })
        .catch(() => {});
    },
    //分页切换
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`);
      this.currentindex = val;
      this.giftListd();
    },
    //搜索
    onSubmit() {
      // console.log(this.Gmanform);
      this.currentindex = 1;
      this.giftListd();
    },
    //取消搜索
    nosubmint() {
      this.Gmanform.cg_id = "";
      this.Gmanform.status = "";
      this.currentindex = 1;
      this.giftListd();
    },
    //复制
    handleClick(e) {
      // console.log(e.secret_key);
      let url = e.secret_key; // 要复制的数据
      let inputNode = document.createElement("input"); // 创建input
      inputNode.value = url; // 赋值给 input 值
      document.body.appendChild(inputNode); // 插入进去
      inputNode.select(); // 选择对象
      document.execCommand("Copy"); // 原生调用执行浏览器复制命令
      inputNode.className = "oInput";
      inputNode.style.display = "none"; // 隐藏
      this.$message({
        type: "success",
        message: "复制成功!"
      });
    },
    // 新增--弹窗
    addPoints() {
      this.titleName = "新增";
      this.pop_up = true;
    },
    //编辑弹窗
    editbox(e) {
      this.titleName = "编辑";
      this.pop_up = true;
      // console.log(e);
      this.Edform.id = e.id;
      this.Edform.cg_id = e.cg_id;
      this.Edform.secret_key = e.secret_key;
    },
    //关闭弹窗
    noadd() {
      this.pop_up = false;
      this.Edform.cg_id = "";
      this.Edform.secret_key = "";
    },
    //弹窗提交
    SubmitAdd() {
      // console.log(this.Edform);
      if (this.titleName == "新增") {
        // giftadd
        let data = {
          cg_id: this.Edform.cg_id,
          secret_key: this.Edform.secret_key,
          currency_id:parseInt(localStorage.getItem('countryId'))
        };
        giftadd(data).then(res => {
          // console.log(res);
          if (res.status_code == 200) {
            this.pop_up = false;
            this.Gmanform.cg_id = "";
            this.Gmanform.status = "";
            this.currentindex = 1;
            this.giftListd();
            this.$message({
              type: "success",
              message: "新增成功!"
            });
          }
        });
      }
      if (this.titleName == "编辑") {
        // giftedit
        let data = {
          id: this.Edform.id,
          cg_id: this.Edform.cg_id,
          secret_key: this.Edform.secret_key,
          currency_id:parseInt(localStorage.getItem('countryId'))
        };
        giftedit(data).then(res => {
          // console.log(res);
          if (res.status_code == 200) {
            this.pop_up = false;
            this.Gmanform.cg_id = "";
            this.Gmanform.status = "";
            this.currentindex = 1;
            this.giftListd();
            this.$message({
              type: "success",
              message: "编辑成功!"
            });
          }
        });
      }
    },
    //选中
    handleSelectionChange(val) {
      // console.log(val);
      this.Checklist = [];
      val.forEach(ele => {
        this.Checklist.push(ele.id);
      });
      // console.log(this.Checklist.toString());
    },
    //导出
    exportto() {
      let data = {
        ids: this.Checklist.toString(),
        type: "gift",
        where: {}
      };
      if (this.Gmanform.status == "" && this.Gmanform.cg_id == "") {
        data.where = "";
      } else if (this.Gmanform.status !== "") {
        data.where.status = this.Gmanform.status;
      } else if (this.Gmanform.cg_id !== "") {
        data.where.cg_id = this.Gmanform.cg_id;
      }
      excelexport(data).then(res => {
        // console.log(res);
        const blob = new Blob([res]);
        const downloadElement = document.createElement("a");
        const href = window.URL.createObjectURL(blob); // 创建下载的链接
        downloadElement.href = href;
        downloadElement.download = "礼品.xlsx"; // 下载后文件名
        document.body.appendChild(downloadElement);
        downloadElement.click(); // 点击下载
        document.body.removeChild(downloadElement); // 下载完成移除元素
        window.URL.revokeObjectURL(href); // 释放掉blob对象
      });
    },
    //导入--上传
    handlePreview(file) {
      // console.log(file);
      let minfile = file.file;
      let form = new FormData();
      form.append("file", minfile);
      form.append("type", "gift");
      form.append("currency_id",localStorage.getItem('countryId'))

      let data = {
        file: minfile,
        type: "category_gift"
      };
      excelimport(form).then(res => {
        if (res.status_code == 200) {
          this.currentindex = 1;
          this.giftListd();
          this.$message({
            type: "success",
            message: "导入成功!"
          });
        }
      });
    },
    //模板下载
    mode() {
      location.href= process.env.VUE_APP_BASE_API + '/template_file/lipin_template.xls'
      // gifttemplate().then(res => {
      //   // console.log(res);
      //   const blob = new Blob([res]);
      //   const downloadElement = document.createElement("a");
      //   const href = window.URL.createObjectURL(blob); // 创建下载的链接
      //   downloadElement.href = href;
      //   downloadElement.download = "礼品模板.xlsx"; // 下载后文件名
      //   document.body.appendChild(downloadElement);
      //   downloadElement.click(); // 点击下载
      //   document.body.removeChild(downloadElement); // 下载完成移除元素
      //   window.URL.revokeObjectURL(href); // 释放掉blob对象
      // });
    }
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.giftdata();
    this.giftListd();
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='scss' scoped>
//@import url(); 引入公共css类
.Gmanagement {
  padding: 20px 30px 0;
  .form_header {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    .btn_box {
      margin-left: 20px;
    }
    .form_ri {
      display: flex;
      .upload-demo {
        margin: 0 10px;
      }
    }
  }
  .form_list {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
  }
  .user_list {
    padding: 20px 0;
  }
}
</style>
<style lang='scss'>
.Gmanagement {
  .form_header {
    .el-form-item {
      margin-bottom: 0;
    }
  }

  .el-table {
    border-top: 1px solid #ebeef5;
    border-left: 1px solid #ebeef5;
    border-right: 1px solid #ebeef5;
  }
}
</style>